import { render, staticRenderFns } from "./CurrentAlarmPage.vue?vue&type=template&id=755751af&"
import script from "./CurrentAlarmPage.vue?vue&type=script&lang=js&"
export * from "./CurrentAlarmPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports